import { FavoriteCustomer } from "models/customers/customers";
import { useRootStore } from "store";

export const getFavoriteCustomers = () => {
  const favoriteCustomers = localStorage.getItem("favorite_customers");
  return favoriteCustomers ? JSON.parse(favoriteCustomers) : [];
};

export const getFavoriteUserCustomer = (
  userId: string
): FavoriteCustomer | undefined => {
  const favoriteCustomersList = getFavoriteCustomers();
  return favoriteCustomersList.find(
    (favorite: FavoriteCustomer) => favorite.userId === userId
  );
};

export const isAlreadyFavorite = (chosenCustomer: FavoriteCustomer) => {
  const userFavoriteCustomer = getFavoriteUserCustomer(chosenCustomer.userId);
  return userFavoriteCustomer?.customerId === chosenCustomer.customerId
    ? true
    : false;
};

export const updateFavoriteCustomerList = (
  chosenCustomer: FavoriteCustomer
) => {
  const setUserFavoriteCustomer =
    useRootStore.getState().global.setUserFavoriteCustomer;
  const updatedList = getFavoriteCustomers().filter(
    (favorite: FavoriteCustomer) => favorite.userId !== chosenCustomer.userId
  );
  if (isAlreadyFavorite(chosenCustomer)) {
    setUserFavoriteCustomer(undefined);
    localStorage.setItem("favorite_customers", JSON.stringify(updatedList));
  } else {
    updatedList.push(chosenCustomer);
    setUserFavoriteCustomer(chosenCustomer);
    localStorage.setItem("favorite_customers", JSON.stringify(updatedList));
  }
};
